import { API } from "aws-amplify";
import { listProperties } from "~/graphql/queries";
import { GRAPHQLFilters, LoaderData } from "~/types";
import * as APITypes from "~/API";
import { getGraphqlFilters } from "~/utils";

export const getPropertyList = async ({
  ownerID,
  ownerType,
  includeDeleted = "exclude",
}: {
  ownerID?: string;
  ownerType?: APITypes.OwnerType;
  includeDeleted?: "all" | "exclude" | "only";
}): Promise<LoaderData<APITypes.Property[]>> => {
  let filters: GRAPHQLFilters = getGraphqlFilters({
    ownerID,
    ownerType,
  });

  // Add _deleted filter based on includeDeleted parameter
  if (includeDeleted === "exclude") {
    filters._deleted = { ne: true };
  } else if (includeDeleted === "only") {
    filters._deleted = { eq: true };
  }
  // If includeDeleted === "all", don't add any _deleted filter
  let items: APITypes.Property[] = [];
  let nextToken: string | null | undefined = undefined;
  try {
    do {
      let response = (await API.graphql({
        query: listProperties,
        variables: {
          filter: filters,
          nextToken,
        },
      })) as { data?: APITypes.ListPropertiesQuery };

      const allUserProperties =
        response.data?.listProperties?.items?.filter(
          (item): item is APITypes.Property => item !== null,
        ) ?? [];
      items.push(...allUserProperties);
      nextToken = response.data?.listProperties?.nextToken;
    } while (nextToken);

    return {
      success: true,
      data: items,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      error,
    };
  }
};
